/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getOrganizations = /* GraphQL */ `
  query getOrganizations {
    getOrganizations {
      name
      description
      alias
    }
  }
`;
export const getCustomerGroups = /* GraphQL */ `
query getCustomerGroups {
  getCustomerGroups {
    name
    description
    alias
  }
}
`;
export const getUsers = /* GraphQL */ `
  query getUsers($role: Role, $provider: String) {
    getUsers(role: $role, provider: $provider) {
      email
      role
      name
      surname
      phone
      company
      active
      id
      sftp
    }
  }
`;
export const getTree = /* GraphQL */ `
  query getTree ($bucket: String!, $father: String, $parent: String) {
    getTree (bucket: $bucket, father: $father, parent: $parent) {
      path,
      name,
      lock_time,
      locked,
      storage_class,
      creation_time,
      creator,
      locked_by,
      size,
      sharing_time,
      shared_by,
      confirmation_time,
      confirmed_by,
      downloaded,
      operator_download_time,
      provider_download_time,
      download_time,
      download_user
    }
  }
`;
export const getLinkedFile = /* GraphQL */ `
  query getLinkedFile ($father: String, $parent: String) {
    getLinkedFile (father: $father, parent: $parent) {
      path,
      name,
      lock_time,
      locked,
      storage_class,
      creation_time,
      creator,
      locked_by,
      size,
      sharing_time,
      shared_by,
      confirmation_time,
      confirmed_by,
      downloaded,
      operator_download_time,
      provider_download_time,
    }
  }
`;
export const getNotLinkedFile = /* GraphQL */ `
  query getNotLinkedFile ($father: String, $parent: String) {
    getNotLinkedFile (father: $father, parent: $parent) {
      path,
      name,
      lock_time,
      locked,
      storage_class,
      creation_time,
      creator,
      locked_by,
      size,
      sharing_time,
      shared_by,
      confirmation_time,
      confirmed_by,
      downloaded,
      operator_download_time,
      provider_download_time,
    }
  }
`; export const searchFile = /* GraphQL */ `
query searchFile ($bucket: String!, $search: String) {
  searchFile (bucket: $bucket, search: $search) {
    path,
    name,
    lock_time,
    locked,
    storage_class,
    creation_time,
    creator,
    locked_by,
    size,
    sharing_time,
    shared_by,
    confirmation_time,
    confirmed_by,
    downloaded,
    operator_download_time,
    provider_download_time,
  }
}
`;
export const getAdCustNotDowload = /* GraphQL */ `
query getAdCustNotDowload {
  getAdCustNotDowload {
    name
    path
    user
    bucket

  }
}
`;
export const getAdCustNotConfirmed = /* GraphQL */ `
query getAdCustNotConfirmed {
  getAdCustNotConfirmed {
    name
    path
    user
    bucket
  }
}
`;
export const getAdProvNotDowload = /* GraphQL */ `
query getAdProvNotDowload {
  getAdProvNotDowload {
    name
    path
    user
    bucket
  }
}
`;
export const getProvNotDowload = /* GraphQL */ `
query getProvNotDowload {
  getProvNotDowload {
    name
    path
    bucket
  }
}
`;
export const getCustNotDowload = /* GraphQL */ `
query getCustNotDowload {
  getCustNotDowload {
    name
    path
    bucket
  }
}
`;
export const getCustNotConfirmed = /* GraphQL */ `
query getCustNotConfirmed {
  getCustNotConfirmed {
    name
    path
    bucket
  }
}
`;
export const getFolderListOperator = /* GraphQL */ `
  query getFolderList {
    getFolderList {
      path
      username
      alias
    }
  }
`;
export const getLinkedUser = /* GraphQL */ `
  query getLinkedUser($path: String!) {
    getLinkedUser(path: $path) {
      username
    }
  }
`;
export const getFile = /* GraphQL */ `
  query getFile($father: String!, $bucket: String!) {
    getFile(father: $father, bucket: $bucket)
  }
`;
export const getDashboardAdmin = /* GraphQL */ `
  query getDashboardAdmin {
    getDashboardAdmin {
      cust_not_down
      cust_not_conf
      prov_not_down
    }
  }
`;
export const getDashboardProvider = /* GraphQL */ `
  query getDashboardProvider {
    getDashboardProvider {
      file_to_down
    }
  }
`;
export const getDashboardCustomer = /* GraphQL */ `
  query getDashboardCustomer {
    getDashboardCustomer {
      file_not_down,
      file_not_conf
    }
  }
`;
export const getFilePath = /* GraphQL */ `
  query getFilePath ($father: String!, $bucket: String!) {
    getFilePath ( father: $father, bucket: $bucket){
      path,
      name
    }
  }
`;
export const getDownloadList = /* GraphQL */ `
  query getDownloadList ($file: String! ) {
    getDownloadList ( file: $file ){
      user,
      group,
      time
    }
  }
`;
export const getConfirmList = /* GraphQL */ `
  query getConfirmList ($file: String! ) {
    getConfirmList ( file: $file ){
      user,
      group,
      time
    }
  }
`;
export const getMakeDeliverableList = /* GraphQL */ `
  query getMakeDeliverableList ($LastKey: String ) {
    getMakeDeliverableList ( LastKey: $LastKey ){
      id
      deliveredBy
      deliveredTo
      move
      sourcePrefix
      targetPrefix
      createdAt
      expiresAt
      status
      sourceBucket
      targetBucket
      LastKey
    }
  }
`;
export const getMe = /* GraphQL */ `
  query getMe {
    getMe {
      active
      company
      email
      id
      name
      phone
      role
      sftp
      surname
    }
  }
`;